var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep13To3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 482,
    viewBox: "0 0 614 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70714 85.1204C8.31664 85.5109 7.68346 85.5109 7.29295 85.1204L0.929003 78.7564C0.538439 78.3659 0.538439 77.7327 0.929003 77.3422C1.31951 76.9517 1.95268 76.9517 2.34319 77.3422L8.00005 82.999L13.6569 77.3422C14.0474 76.9517 14.6806 76.9517 15.0711 77.3422C15.4617 77.7327 15.4617 78.3659 15.0711 78.7564L8.70714 85.1204ZM593 2.00001L28.0001 2.00024L28.0001 0.00024223L593 8.3048e-06L593 2.00001ZM614 21L614 482L612 482L612 21L614 21ZM9.00006 21.0002L9.00005 84.4132L7.00005 84.4132L7.00006 21.0002L9.00006 21.0002ZM28.0001 2.00024C17.5067 2.00025 9.00006 10.5068 9.00006 21.0002L7.00006 21.0002C7.00006 9.40226 16.4021 0.000247057 28.0001 0.00024223L28.0001 2.00024ZM593 8.3048e-06C604.598 3.47812e-06 614 9.40202 614 21L612 21C612 10.5066 603.493 2 593 2.00001L593 8.3048e-06Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep13To3);
export default __webpack_public_path__ + "static/media/step_13_to_3.4c1d9adedd2d1ee010dc3eae4e3ab004.svg";
export { ForwardRef as ReactComponent };